<template>
  <div>
    <!-- 저장하기 -->
    <div class="btn-group-justify-end">
      <div class="button is-primary" @click="saveData">저장하기</div>
    </div>

    <div class="box">
      <admin-box-item title="서비스 플랜 등록/수정">
        <admin-form-item label="멤버쉽명">
          <input class="input"
                 :value="value.membership"
                 @input="e => value.membership = e.target.value"
                 type="text">
        </admin-form-item>
        <admin-form-item label="블록 템플릿 무제한 이용권">
          <input class="input"
                 :value="value.usage.template"
                 @input="e => value.usage.template = e.target.value"
                 type="text">
        </admin-form-item>
        <admin-form-item label="프론트 서비스 제공 범위">
          <input class="input"
                 :value="value.usage.front"
                 @input="e => value.usage.front = e.target.value"
                 type="text">
        </admin-form-item>
        <admin-form-item label="회원가입수">
          <input class="input"
                 style="width:100px"
                 :value="value.usage.user"
                 @input="e => value.usage.user = e.target.value"
                 type="number">
        </admin-form-item>
        <admin-form-item label="파트너 등록 수">
          <input class="input"
                 style="width:100px"
                 :value="value.usage.partner"
                 @input="e => value.usage.partner = e.target.value"
                 type="number">
        </admin-form-item>
        <admin-form-item label="상품 등록 수">
          <input class="input"
                 style="width:100px"
                 :value="value.usage.product"
                 @input="e => value.usage.product = e.target.value"
                 type="number">
        </admin-form-item>
        <admin-form-item label="상품 카테고리 수">
          <input class="input"
                 style="width:100px"
                 :value="value.usage.category"
                 @input="e => value.usage.category = e.target.value"
                 type="number">
        </admin-form-item>
        <admin-form-item label="관리자 계정 갯수">
          <input class="input"
                 style="width:100px"
                 :value="value.usage.admin_account"
                 @input="e => value.usage.admin_account = e.target.value"
                 type="number">
        </admin-form-item>
      </admin-box-item>
    </div>
  </div>
</template>
<script>
  export default {
    name: "ServicePlanDetail",
    data() {
      return {
        value: {
          membership: '',
          usage: {
            user: '',
            front: '',
            partner: '',
            product: '',
            category: '',
            template: '',
            admin_account: ''
          }
        }
      }
    },
    created() {
      this.getData();
    },
    methods: {
      getData() {
        if(this.$route.query.id) {
          this.$axios.get(`admin/launchpack/service_plan/${this.$route.query.id}`).then(res=>{
            this.value = res.data;
          })
        }
      },
      saveData() {
        let url = 'admin/launchpack/service_plan';
        if(this.$route.query.id) {
          this.$axios.patch(url + `/${this.$route.query.id}`, this.value).then(res=>{
            this.toast('저장되었습니다.')
            this.$router.replace(this.getPath('launchpack/service_plan'))
          })
        } else {
          this.$axios.post(url, this.value).then(res=>{
            this.toast('저장되었습니다.')
            this.$router.replace(this.getPath('launchpack/service_plan'))
          })
        }
      }
    }
  }
</script>
<style lang="stylus" scoped>
</style>
